//rgb array needed for jspdf-autotable in reports and are hardcoded here to avoid
//costly conversion to extract the values otherwise needed
//update the RGBArr whenever changing the primary color so reports match the webpage

export default (score) => {
  var color, bgColor, colorRGBArr;
  switch (score) {
    case 1:
      color = "purple";
      colorRGBArr = [128, 0 , 128];
      bgColor = "rgb(229, 211, 240)";
      break;
    case 2:
      color = "limegreen";
      colorRGBArr = [0, 128, 0];
      bgColor = "rgb(224, 236, 228)";
      break;
    case -1:
      color = "rgb(231, 216, 80)";
      colorRGBArr = [231, 216, 80];
      bgColor = "rgb(254, 252, 228)";
      break;
    case -2:
      color = "orange";
      colorRGBArr = [255, 165, 0];
      bgColor = "rgb(255, 243, 232)";
      break;
    case -3:
      color = "red";
      colorRGBArr = [255, 0 , 0];
      bgColor = "rgb(245, 218, 218)";
      break;
    default:
      color = "#76d6e2";
      colorRGBArr =[153, 225, 234];
      bgColor = "rgba(153, 225, 234, 0.3)"
      break;
  }
  return {
    primary: color,
    primaryRGBArr: colorRGBArr,
    background: bgColor
  }
}
